import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Park } from '../../Pages/Public/Park.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteParks = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    let msg = 0;
    const [parks, setParks] = useState([]);
    const [att, setAtt] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataAtt = await fetch(`${backend}/nav/attractions`, GetHeaders(guest));
            const att = await dataAtt.json();
            setAtt(att);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                {navParks.map((el, i) => {
                    return (<Route path={el.proute} element={<Park id={el.pid} navParks={navParks} att={att} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}